import _ from 'lodash';
import stringHash from 'string-hash';
import xhr from 'xhr';

import generateId from 'lib/generateId';
import Observable from 'lib/ObservableMixin.js';
import getDomain from 'lib/getDomain.js';
import loadConfiguration from 'configuration/loadConfiguration';

const COOKIE_PREFIX = 'gladlyCohort-';

export default class ConfigurationGateway {
  constructor({ appId, cdn, cookie }) {
    this.appId = appId;
    this.cdn = cdn;
    this.cookie = cookie;
    this.cookieName = `${COOKIE_PREFIX}${this.appId}`;
    this.getCookie();
  }

  getCookie() {
    if (!this.cookie.get(this.cookieName)) {
      this.cookie.set(this.cookieName, { id: generateCohortId() }, { expires: 1, domain: getDomain() });
    }

    this.cohortId = this.cookie.get(this.cookieName).id;
  }

  refreshConfig() {
    loadConfiguration(this.cdn, this.appId)
      .then(this.onRefreshSuccess.bind(this))
      .catch(this.onRefreshFailure.bind(this));
  }

  onRefreshFailure(failure) {
    this.notifyObservers('handleRefreshConfigError', failure);
  }

  onRefreshSuccess(serverConfiguration) {
    this.notifyObservers('handleRefreshConfigSuccess', { config: serverConfiguration });
  }
}

function generateCohortId() {
  let id = generateId();
  while (stringHash(id) % 100 === 0) {
    id = generateId();
  }
  return id;
}

_.extend(ConfigurationGateway.prototype, Observable);
